//import { useStaticQuery, graphql } from "gatsby";
//import React from "react";
import { Popup, Icon } from "semantic-ui-react";
import { VehiclyTypePopupContainer, QuickHelpInfo, QuickHelpInfoDarkTheme } from "./CombinationFinder.styles";
import { H5, PopupContentText } from "@styles/Global.styles";
import { useEffect, useState } from "react";
import { VehicleTypeTooltip } from "~/_models";

interface QuickHelpInfoLinkProps {
    darkTheme: boolean;
}

const QuickHelpInfoLink = ({ darkTheme }: QuickHelpInfoLinkProps) =>{
    const [data, setData] = useState<any>(null);
    
    useEffect(() =>{
        
        const fetchData = async () => {
            try {
                const result = await fetch("/api/content-data", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      codeName: "vehicle_type_tooltip", 
                      depthParameter: 2,
                    }),
                  });
                  
                setData(await result.json());
              } catch (err) {
                console.error("Error fetching data:", err);
              }
        }
        fetchData();
    }, [])
    
    if (data == undefined) {
        return (<></>)
    } 
    
    return (
        darkTheme ? 
            <QuickHelpInfoDarkTheme>
                <Popup basic position='right center' trigger={<Icon name='question circle' color='orange' size='small' style={{display: 'flex', alignItems: 'center'}}/>}>
                    <VehiclyTypePopupContainer>
                        <H5>{data.elements.heading.value}</H5>
                        <PopupContentText dangerouslySetInnerHTML={{ __html: data.elements.body.value }}></PopupContentText>
                    </VehiclyTypePopupContainer>
                </Popup>
            </QuickHelpInfoDarkTheme> : 
            <QuickHelpInfo>
                <Popup basic position='right center' trigger={<Icon name='question circle' color='orange' size='small' style={{display: 'flex', alignItems: 'center'}}/>}>
                    <VehiclyTypePopupContainer>
                        <H5>{data.elements.heading.value}</H5>
                        <PopupContentText dangerouslySetInnerHTML={{ __html: data.elements.body.value }}></PopupContentText>
                    </VehiclyTypePopupContainer>
                </Popup>
            </QuickHelpInfo>
        
        
    )
}
export default QuickHelpInfoLink